import { useToast } from "@/components/ui/use-toast";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

const WelcomeSection = () => {
  const { toast } = useToast();

  const handleRefresh = () => {
    toast({
      title: "Refreshing Dashboard",
      description: "Dashboard data is being updated...",
    });
  };

  return (
    <div className="bg-gradient-to-r from-[#F8F7FF] via-white to-[#E5DEFF] rounded-2xl p-8 border border-[#E5DEFF] shadow-lg transition-all duration-300 hover:shadow-xl">
      <div className="max-w-3xl space-y-3">
        <h1 className="text-2xl md:text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#9b87f5] to-[#8B5CF6]">
          Welcome back, Vendor
        </h1>
        <p className="text-muted-foreground">
          Here's what's happening with your store today.
        </p>
      </div>
      <Button 
        variant="outline"
        onClick={handleRefresh}
        className="flex items-center gap-2 hover:shadow-md transition-all duration-200 mt-4"
      >
        <RefreshCw className="h-4 w-4" />
        Refresh Data
      </Button>
    </div>
  );
};

export default WelcomeSection;